import NotificationStore from "./NotificationStore";

const notificationStore = new NotificationStore();

export default notificationStore;
